import styled from 'styled-components'

export const HelpText = styled.p`
  margin-bottom: 20px;
  color: #666;
  font-size: 14px;
`
